import { render } from "./DashboardAbout.vue?vue&type=template&id=5202ecdd&scoped=true&ts=true"
import script from "./DashboardAbout.vue?vue&type=script&lang=ts"
export * from "./DashboardAbout.vue?vue&type=script&lang=ts"

import "./DashboardAbout.vue?vue&type=style&index=0&id=5202ecdd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5202ecdd"]])

export default __exports__